module.exports = __webpack_public_path__ + "a700c9cb1f636e7161fbcf5247470817.fbx";